/* eslint-disable camelcase */
import React from 'react';
import { jsx as ___EmotionJSX } from "@emotion/react";
export var currentMonthReferenceColumns = [{
  name: 'Кр. посредник',
  value: 'franchisee_name'
}, {
  name: 'Офис',
  value: 'office_name',
  sm: true
}, {
  name: 'Общо',
  render: function render(_ref) {
    var total = _ref.total,
        currency = _ref.currency;
    return ___EmotionJSX("span", {
      "data-value": "total_principal"
    }, total, " ", currency);
  }
}, {
  name: 'Събр. главница',
  render: function render(_ref2) {
    var total_paid_principals = _ref2.total_paid_principals,
        currency = _ref2.currency;
    return ___EmotionJSX("span", {
      "data-value": "total_paid_principals"
    }, total_paid_principals, " ", currency);
  },
  invisibleBelow: 3000
}, {
  name: 'Проср. главници',
  render: function render(_ref3) {
    var total_late_principals = _ref3.total_late_principals,
        currency = _ref3.currency;
    return ___EmotionJSX("span", {
      "data-value": "total_late_principals"
    }, total_late_principals, " ", currency);
  },
  invisibleBelow: 3000
}, {
  name: 'Очакв. главници',
  render: function render(_ref4) {
    var total_future_principals = _ref4.total_future_principals,
        currency = _ref4.currency;
    return ___EmotionJSX("span", {
      "data-value": "total_future_principals"
    }, total_future_principals, " ", currency);
  },
  invisibleBelow: 3000
}, {
  name: 'Общо главници',
  render: function render(_ref5) {
    var total_principals = _ref5.total_principals,
        currency = _ref5.currency;
    return ___EmotionJSX("span", {
      "data-value": "total_principals"
    }, total_principals, " ", currency);
  },
  invisibleBelow: 3000
}, {
  name: 'Събр. лихви',
  render: function render(_ref6) {
    var total_paid_interests = _ref6.total_paid_interests,
        currency = _ref6.currency;
    return ___EmotionJSX("span", {
      "data-value": "total_paid_interests"
    }, total_paid_interests, " ", currency);
  },
  invisibleBelow: 3000
}, {
  name: 'Проср. лихви',
  render: function render(_ref7) {
    var total_late_interests = _ref7.total_late_interests,
        currency = _ref7.currency;
    return ___EmotionJSX("span", {
      "data-value": "total_late_interests"
    }, total_late_interests, " ", currency);
  },
  invisibleBelow: 3000
}, {
  name: 'Очакв. лихви',
  render: function render(_ref8) {
    var total_future_interests = _ref8.total_future_interests,
        currency = _ref8.currency;
    return ___EmotionJSX("span", {
      "data-value": "total_future_interests"
    }, total_future_interests, " ", currency);
  },
  invisibleBelow: 3000
}, {
  name: 'Общо лихви',
  render: function render(_ref9) {
    var total_interests = _ref9.total_interests,
        currency = _ref9.currency;
    return ___EmotionJSX("span", {
      "data-value": "total_interests"
    }, total_interests, " ", currency);
  },
  invisibleBelow: 3000
}, {
  name: 'Събр. такси',
  render: function render(_ref10) {
    var total_paid_fees = _ref10.total_paid_fees,
        currency = _ref10.currency;
    return ___EmotionJSX("span", {
      "data-value": "total_paid_fees"
    }, total_paid_fees, " ", currency);
  },
  invisibleBelow: 3000
}, {
  name: 'Проср. такси',
  render: function render(_ref11) {
    var total_late_fees = _ref11.total_late_fees,
        currency = _ref11.currency;
    return ___EmotionJSX("span", {
      "data-value": "total_late_fees"
    }, total_late_fees, " ", currency);
  },
  invisibleBelow: 3000
}, {
  name: 'Очакв. такси',
  render: function render(_ref12) {
    var total_future_fees = _ref12.total_future_fees,
        currency = _ref12.currency;
    return ___EmotionJSX("span", {
      "data-value": "total_future_fees"
    }, total_future_fees, " ", currency);
  },
  invisibleBelow: 3000
}, {
  name: 'Общо такси',
  render: function render(_ref13) {
    var total_fees = _ref13.total_fees,
        currency = _ref13.currency;
    return ___EmotionJSX("span", {
      "data-value": "total_fees"
    }, total_fees, " ", currency);
  },
  invisibleBelow: 3000
}];